module.exports = __webpack_public_path__ + "static/img/3-6.7.5.1e818b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/5/3-6.7.5.png
// module id = iy2r
// module chunks = 0